import React, { useState } from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { useExportData } from "@planzone/view-models";
import { ExportsDataTypes, ExportsFormats } from "@planzone/dto";

import { Checkbox } from "@common/checkbox";
import { Props } from "./types";
import styles from "./styles.scss";
import { Button } from "@common/button";

function ResourcesReport(props: Props) {
  const { t } = useTranslation();
  const [isChecked, setIsChecked] = useState(false);
  const { isRequestPending, exportData } = useExportData();

  return (
    <div
      className={classNames(styles.resourceReport, {
        [styles.checked]: isChecked,
      })}
    >
      <div className={styles.checkbox} onClick={() => setIsChecked(!isChecked)}>
        <Checkbox isChecked={isChecked} />
      </div>
      <div className={styles.col}>
        <h2 className={styles.name}>
          {t("exportReportsPage.resourceReport.title")}
        </h2>
        <p className={styles.description}>
          {t("exportReportsPage.resourceReport.subTitle")}
        </p>
      </div>
      {isChecked && (
        <Button
          className={styles.button}
          type="submit"
          status={isRequestPending ? "pending" : "none"}
          press={() =>
            exportData({
              fileName: props.fileName,
              author: props.author,
              data: {
                type: ExportsDataTypes.RESOURCES_REPORT,
                data: {
                  planzone: props.planzone,
                },
              },
              format: ExportsFormats.EXCEL,
            })
          }
        >
          {t("exportReportsPage.download")}
        </Button>
      )}
    </div>
  );
}

export { ResourcesReport };
